/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Custom_TitleInputs */

const en_admin_settings_custom_title = /** @type {(inputs: Admin_Settings_Custom_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Custom Configs`)
};

/**
* | output |
* | --- |
* | "Custom Configs" |
*
* @param {Admin_Settings_Custom_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_settings_custom_title = /** @type {((inputs?: Admin_Settings_Custom_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Custom_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_settings_custom_title(inputs)
});
export { admin_settings_custom_title as "admin.settings.custom.title" }